import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Card, Container, Row, Col, Spinner } from 'react-bootstrap';

const API_URL = process.env.REACT_APP_API_URL;

function NewsList() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get(`${API_URL}/news`);
        setNews(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3 text-muted">Đang tải tin tức...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-5 text-center">
        <div className="alert alert-danger border-0 shadow-sm" style={{ borderRadius: '12px' }}>
          Lỗi: {error.message}
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-4">
      <div className="mb-5">
        <h1 className="fw-bold mb-1">Tin Tức</h1>
        <p className="text-muted small">Cập nhật những diễn biến mới nhất từ giải đấu</p>
      </div>
      <Row className="g-3">
        {news.map((article) => (
          <Col md={6} lg={4} xs={12} key={article.id}>
            <Card className="h-100 border-0 shadow-soft animate-fade" style={{ borderRadius: '12px', transition: 'all 0.3s ease' }}>
              <Card.Body className="p-4 d-flex flex-column justify-content-between">
                <Link to={`/news/${article.id}`} className="text-decoration-none text-dark mb-4">
                  <h6 className="fw-bold mb-0 lh-base" style={{ fontSize: '1rem', display: '-webkit-box', WebkitLineClamp: '2', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                    {article.title}
                  </h6>
                </Link>
                <div className="d-flex justify-content-between align-items-center">
                  <Link to={`/news/${article.id}`} className="text-decoration-none small fw-bold text-primary text-uppercase tracking-wider">
                    Chi tiết →
                  </Link>
                  <small className="text-muted opacity-50" style={{ fontSize: '0.75rem' }}>
                    {article.created_at ? new Date(article.created_at).toLocaleDateString('vi-VN') : ''}
                  </small>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default NewsList;
